document.addEventListener('click', function (e) {
  const button = e.target.closest('.cuir-variante');
  if (!button) return;

  const container = button.closest('.cuir-variantes');
  if (!container) return;

  container
    .querySelectorAll('.cuir-variante')
    .forEach(el => el.classList.remove('active'));

  button.classList.add('active');

  const input = document.getElementById('cuir-selected-color');
  if (input) {
    input.value = button.dataset.couleur;
  }

  console.log('Couleur sélectionnée :', button.dataset.couleur);
});
